// SPDX-License-Identifier: LicenseRef-Proprietary

import React from "react";
import "./EvidenceDrawer/EvidenceDrawer.css";

interface EvidenceBubbleProps {
  onClick: () => void;
  isOpen: boolean;
  "aria-expanded": boolean;
  "aria-label": string;
}

export const EvidenceBubble = React.forwardRef<HTMLButtonElement, EvidenceBubbleProps>(
  ({ onClick, isOpen, "aria-expanded": ariaExpanded, "aria-label": ariaLabel }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className="evidence-drawer__bubble"
        onClick={onClick}
        aria-expanded={ariaExpanded}
        aria-label={ariaLabel}
      >
        <div className="evidence-drawer__bubble-icon">
          <span className="evidence-drawer__wave" aria-hidden="true" />
          <div>
            <div className="evidence-drawer__bubble-label">Evidence</div>
          </div>
        </div>
      </button>
    );
  }
);

EvidenceBubble.displayName = "EvidenceBubble";

